/* src/app/home/partials/jobs-this-week-graph/jobs-this-week-graph.component.scss */
b {
  color: #1e293b;
  font-size: 0.95rem;
}
hr {
  margin: 0.5rem 0 0.75rem;
  border-color: #eef2f6;
}
/*# sourceMappingURL=jobs-this-week-graph.component.css.map */
